// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#editSearch__bigBoard,
#editSearch__smallBoard {
    top: 15vh;
}

#editSearch__bigBoard {
    width: 85%;
    height: 80vh;
}

`, "",{"version":3,"sources":["webpack://./src/pages/userCollectedData/savedSearchesTab/editSearch/EditSearch.css"],"names":[],"mappings":"AAAA;;IAEI,SAAS;AACb;;AAEA;IACI,UAAU;IACV,YAAY;AAChB","sourcesContent":["#editSearch__bigBoard,\n#editSearch__smallBoard {\n    top: 15vh;\n}\n\n#editSearch__bigBoard {\n    width: 85%;\n    height: 80vh;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
